import type { ITenant } from 'types/globals';
import { isTenantOnboardingComplete } from 'utils/isTenantOnboardingComplete';

export function isTenantOnboardingSkipped(tenant: ITenant | null): boolean {
  if (!tenant) return false;
  return tenant.is_onboarding_skipped === true;
}

/**
 * Main app (`OnboardingGuard` requireCompleted) allows access when skipped is true,
 * even if `is_onboarding_completed === false` (same shell access as completed).
 */
export function canAccessMainAppDespiteIncompleteOnboarding(
  tenant: ITenant | null,
): boolean {
  return isTenantOnboardingSkipped(tenant);
}

/**
 * Sidebar progress card: incomplete + skipped tenant, super user only.
 * Non–super users cannot use Admin Initial Setup (`/onboarding-setup`); the card navigates there.
 */
export function shouldShowOnboardingSkippedProgressInSidebar(
  tenant: ITenant | null,
  isSuperUser: boolean,
): boolean {
  if (!tenant || !isSuperUser) return false;
  return (
    !isTenantOnboardingComplete(tenant) && isTenantOnboardingSkipped(tenant)
  );
}

/** Super user must complete the full-screen wizard when not complete and not skipped. */
export function shouldForceSuperUserOnboarding(
  tenant: ITenant | null,
): boolean {
  if (!tenant) return false;
  return (
    !isTenantOnboardingComplete(tenant) && !isTenantOnboardingSkipped(tenant)
  );
}
